
<main>
    <div class="city-search">
        <div class="filtering">
            <form>

                <input type="search" class="form-control" #filter (keyup)="searchMember($event)"
                    placeholder="સભ્યો શોધો.." />
                <i class="ti ti-search"></i>

            </form>
            <i class="ti ti-filter cursorClass" (click)="openBottomSheet()"></i>
            <i class="ti ti-refresh cursorClass" (click)="getMainMember()"></i>
            <i *ngIf="userTypeId == 1" class="ti ti-plus cursorClass"
                    (click)="addMember(0,'addNewMainMember')"></i>

        </div>
    </div>

    <div class="main-members">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
            *ngFor="let data of memberListData ; let i = index" (click)="getChildMemberList(data)"
            (opened)="panelOpenState = true" (closed)="panelOpenState = false"
            (click)="currentOpenPanelIndex = currentOpenPanelIndex === i ? -1 : i"
            [expanded]="currentOpenPanelIndex === i">
            <mat-expansion-panel-header>
                <mat-panel-title (click)="addMember(data.user_id,'editMainMember')"
                    [ngClass]="mainMemberId == 1 ? 'disabled-div' : '' ">
                    <div class="member-list-item">
                        <a class="plus-member-icon" (click)="addMember(data.user_id,'Add')"><i
                                class="ti ti-plus"></i></a>
                        <div *ngIf="data.image!= '' ">
                            <img [src]="baseUrl+''+data.image+'?date='+data.dateTimeStamp">
                        </div>
                        <div *ngIf="data.image == '' ">
                            <img src="../../../assets/img/user_.jpg" />
                        </div>
                        <div>
                            <h5>{{data.name}} </h5>
                            <p>{{data.contact_no}}</p>
                            <p *ngIf="data.password">Password: {{data.password}}</p>
                            <p>{{data.business}}
                                <span *ngIf="data.business && data.village_name"> | </span>
                                  {{data.village_name}}</p>
                            <p *ngIf="data.death_date != '' " class="text-danger"><b> અવસાન પામેલ છે
                                </b></p>
                        </div>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div *ngIf="!loadingChildData && childListData.length <= 0" class="text-center">
                <span class="text-danger ">No Data Found</span>
            </div>
            <div *ngIf="childListData.length > 0">
                <div class="main-members" *ngFor="let data1 of childListData">
                    <div class="member-list-item" (click)="addMember(data1.user_id,'Edit')">
                        <div *ngIf="data1.image!= '' ">
                            <img [src]="baseUrl+''+data1.image">
                        </div>
                        <div *ngIf="data1.image == '' ">
                            <img src="../../../assets/img/user_.jpg" />
                        </div>
                        <div>
                            <h5>{{data1.name}}</h5>
                            <p>{{data1.business}} <span *ngIf="data1.business && data1.city_name">|</span>{{data1.city_name}}</p>
                            <p class="text-danger" *ngIf="data1.death_date != '' "><b>અવસાન પામેલ છે </b></p>
                        </div>
                    </div>
                </div>
            </div>

        </mat-expansion-panel>
    </div>
</main>